export default {
  common: {
    appName: 'ハニーバッガーエンターテインメント',
    confirm: '確認',
    cancel: 'キャンセル',
    submit: '送信',
    save: '保存',
    usernameRequired: 'ユーザー名を入力してください。',
    passwordRequired: 'パスワードを入力してください。',
    viewMore: 'もっと見る',
    refreshSuccess: '更新しました',
    noMore: 'これ以上ありません',
    emptyData: 'データがありません',
  },
  footer: { home: 'ホーム', lottery: '宝くじ', game: '予約', video: '動画', mine: 'マイページ' },
  lang: { title: '言語 / Language', current: '現在の言語' },
  home: {
    recommendedTasks: 'おすすめタスク',
    popularRanking: '人気ランキング',
    hotRecommend: '人気のおすすめ',
    playCount: '再生:{count}',
    noticeLoading: '取得中...',
  },
  game: {
    hallTitle: '予約ホール',
    categoryAll: 'すべて',
  },
  choose: {
    title: 'コンパニオン',
    tabCities: '都市一覧',
    tabProcess: '流れと料金',
    privacyNotice: '当プラットフォームは、ネット上で最も本物のコンパニオン・ビジネスアテンド・同エリアの情熱的な時間をご提供します。お客様のプライバシー保護のため、ご入会は案内係へのご連絡または上級会員による実名推薦のみ受け付けております。',
    resourcesQ: 'どのような女性がいますか？',
    resourcesA: 'インフルエンサー、モデル、CA、若手モデル、大学生など、お客様の思い描く女性をご用意できます。',
    scopeQ: 'サービス範囲は？',
    scopeA: '同エリアは無料、全国どこへでもお伺いします。国内1・2線都市は現地対応、3線都市も案内係にご相談いただければ手配いたします。',
    book: '予約',
    contactConcierge: 'コンサルタントまたは案内係にご連絡ください',
    cityNames: {
      beijing: '北京',
      shanghai: '上海',
      guangzhou: '広州',
      shenzhen: '深圳',
      nanjing: '南京',
      changsha: '長沙',
      chongqing: '重慶',
      xian: '西安',
    },
  },
  lottery: {
    gameRecord: 'タスク記録',
    orderList: 'タスクシート',
    orderItemDetail: '1注 X{money} = {money}',
    clearOrder: 'シートを消去',
    confirmSubmit: '確認して送信',
    availableBalance: '利用可能残高',
    yuan: '元',
    currentPick: '現在の選択：',
    amountPerBet: '1注あたりの金額：',
    amountPlaceholder: '金額を入力してください',
    amountInvalid: '金額が正しくありません！',
    fillAmount: '金額を入力してください！',
    selectNumberFirst: '番号を選択してください！',
    insufficientBalance: '残高が不足しています。カスタマーサポートまでご連絡ください！',
    notSelected: '未選択',
    contactAdminForTask: 'このタスクを利用するには管理者へご連絡ください！',
    drawSuccess: '抽選結果発表、期号：{expect}',
    periodNumber: '期号',
    betUnit: '件',
    totalAmountLabel: '合計金額：',
    totalCountLabel: '合計件数：',
    drawResult: '抽選番号',
    big: '大',
    small: '小',
    single: '単',
    doubleNum: '双',
    rules: {
      title: '遊び方',
      tipTitle: '遊び方のヒント',
      tipDetail: '選べる合計値の形態から番号を選んで賭けます。',
      winTitle: '当選について',
      winDetail: '3つの抽選番号の合計が11〜18の場合は大、3〜10の場合は小。',
      exampleTitle: '投注の例',
      exampleDetail: '投注：小　抽選番号：123 → 結果：小',
    },
  },
  mine: {
    accountDetail: {
      kind: { recharge: 'チャージ', withdraw: '出金', game: 'ベット' },
    },
    withdraw: {
      amountLabel: '出金額 (元)',
      all: 'すべて',
      limitRule1: '1. 1回あたりの上限：最小{min}元、最大{max}元',
      limitRule2: '2.出金回数：1日最大{num}回まで',
      limitRule3: '3.着金時間：通常5分钟左右、早ければ2分以内にご連絡します',
      limitTitle: '上限について',
      balanceLabel: '残高：',
      submit: '今すぐ出金',
      amountInvalid: '正しい金額を入力してください',
    },
    bindCard: {
      formLabel: '受取カード情報を入力してください',
      bankidLabel: 'カード番号',
      bankidPlaceholder: '実際のカード番号を入力してください',
      bankLabel: '銀行名',
      bankPlaceholder: '銀行を選択してください',
      notice: 'お客様の資金安全のため、本名と出金パスワードを設定してください。本名と口座名義が異なる場合、出金はできません。',
      submit: 'カード登録を確認',
      bankidRequired: 'カード番号を入力してください！',
      bankRequired: '銀行を選択してください！',
    },
    setbank: {
      title: '受取カード情報',
      addCard: '受取カードを追加',
      tips: '注意：大手商業銀行に紐付けてください。変更が必要な場合はオンラインカスタマーサポートまでご連絡ください。',
      setNameFirst: '氏名を設定してから銀行カードを紐付けてください！',
      setPayPasswordFirst: '出金パスワードを設定してから銀行カードを紐付けてください！',
    },
    setPayPassword: {
      firstPrompt: '出金パスワードを入力してください',
      secondPrompt: '出金パスワードをもう一度入力してください',
      incomplete: '入力してください',
      mismatch: 'パスワードが一致しません！',
    },
    setLoginPassword: {
      oldPassword: '旧パスワード',
      oldPasswordPlaceholder: '現在のパスワードを入力してください',
      newPassword: '新しいパスワード',
      newPasswordPlaceholder: '新しいパスワードを入力してください',
      confirmPasswordPlaceholder: '新しいパスワードをもう一度入力してください',
      incomplete: 'すべて入力してください！',
      mismatch: 'パスワードが一致しません',
    },
    setname: {
      nameLabel: '氏名',
      namePlaceholder: '本名を入力してください',
      notice: 'アカウントの安全のため、本名は紐付けた銀行カードの名義と一致する必要があります',
      alreadySet: '重複して設定しないでください！',
      nameRequired: '氏名を入力してください！',
    },
    setsex: {
      male: '男性',
      female: '女性',
    },
    infomation: {
      avatar: 'アバター',
      chooseAvatar: 'アバターを選択',
      realName: '本名',
      notSet: '未設定',
      gender: '性別',
      unknown: '不明',
      bindInfo: '紐付け情報',
      bound: '紐付け済み',
      none: 'なし',
    },
    index: {
      recharge: '入金',
      withdraw: '出金',
      myWallet: 'マイウォレット',
      details: '明細',
      balanceLabel: '残高：',
      personalReport: '個人レポート',
      accountDetail: 'アカウント明細',
      profileCenter: 'プロフィール',
      notice: 'お知らせ',
      customerService: 'カスタマーサポート',
      completeTaskFirst: '先に登録タスクを完了してください',
      contactServiceToRecharge: '入金についてはカスタマーサポートへお問い合わせください',
      setPayoutCardFirst: '先に受取カードを設定してください',
      featureDisabled: 'この機能はまだ利用できません',
      accountOffline: 'アカウントがオフラインです',
      loginRegister: 'ログイン/登録',
      loginHint: 'ログイン後に表示',
    },
    setting: {
      basicInfo: '基本情報',
      loginPassword: 'ログインパスワード',
      payPassword: '支払パスワード',
      payPasswordAlreadySet: '支払パスワードは設定済みです！',
      signOut: 'ログアウト',
    },
    gameRecord: {
      betAmount: '賭け金額：{money}',
      betTime: '賭け時間：{time}',
      settleTime: '精算時間：{time}',
    },
    withdrawRecord: {
      amount: '出金額：{money}',
      desc: '出金備考：{desc}',
      submitTime: '申請時間：{time}',
      reviewTime: '審査時間：{time}',
    },
    report: {
      profitLabel: '損益',
      formulaTip: '損益 = 当選金額 - 賭け金額 + 入金 - 出金',
      playAmount: '賭け金額',
      rechargeAmount: '入金金額',
      withdrawAmount: '出金額',
      winAmount: '当選金額',
    },
    service: {
      contact: '今すぐ問い合わせる',
      slogan: 'ご不明な点はいつでもお問い合わせください',
    },
  },
  video: {
    hallTitle: 'ビデオ劇場',
    hotRecommend: '人気のおすすめ',
    playCount: '再生:{count}',
    playCountSuffix: '{count}回再生',
    rechargeToWatch: 'ご入金後に動画をご視聴ください！',
  },
  recharge: {
    title: '入金',
    chooseCoin: '通貨を選択',
    address: '入金アドレス',
    copy: 'アドレスをコピー',
    copied: 'コピーしました',
    amount: '入金金額',
    uploadShot: '送金スクリーンショットをアップロード',
    submit: '入金申請を送信',
    pending: '審査中',
    done: '入金済み',
    rejected: '却下されました',
  },
  payMethod: {
    title: '受け取り方法を選択',
    bankCard: '銀行カード',
    wallet: '暗号資産ウォレット',
    unbind: '解除',
    bindNew: '新しいアドレスを登録',
    confirmUnbind: 'この受け取り方法を解除しますか？',
    payPassword: '出金パスワード',
    wrongPassword: '出金パスワードが正しくありません',
    chooseFirst: '先に受け取り方法を選択してください',
  },
  router: {
    Index: { title: 'ホーム' },
    Home: { title: 'ホーム' },
    Choose: { title: 'コンパニオン' },
    List: { title: 'コンパニオン一覧' },
    Profile: { title: 'コンパニオン詳細' },
    Mine: { title: 'マイページ' },
    Video: { title: '動画' },
    Game: { title: 'ゲーム' },
    Login: { title: 'ログイン' },
    Register: { title: '登録' },
    ServiceOnline: { title: 'カスタマーサポート' },
    ServicePage: { title: 'カスタマーサポート' },
    Setting: { title: '設定' },
    Infomation: { title: '基本情報' },
    Setname: { title: '本名変更' },
    Setsex: { title: '性別変更' },
    SetPayPassword: { title: '支払いパスワード' },
    SetLoginPassword: { title: 'ログインパスワード' },
    Lottery: { title: '宝くじ' },
    Notice: { title: 'お知らせ' },
    PlayVideo: { title: '動画再生' },
    Setbank: { title: '出金カード追加' },
    BindCard: { title: '出金カード追加' },
    Withdraw: { title: '出金' },
    Recharge: { title: '入金' },
    Personalreport: { title: '個人レポート' },
    WithdrawRecord: { title: '出金履歴' },
    AccountDetail: { title: 'アカウント明細' },
    GameRecord: { title: 'ゲーム履歴' },
  },
  captcha: {
    placeholder: '画像認証コード',
    refresh: 'タップで更新',
    error: '認証コードが正しくありません',
    required: '認証コードを入力してください',
  },
  login: {
    title: 'ログイン',
    usernamePlaceholder: 'ユーザー名を入力してください',
    passwordPlaceholder: 'パスワードを入力してください',
    forgotPassword: 'パスワードをお忘れですか？',
    noAccountRegister: 'アカウントをお持ちでない方は今すぐ登録',
    submit: 'ログイン',
  },
  register: {
    title: '登録',
    usernamePlaceholder: 'ユーザー名を入力してください（6～12文字の半角英数字）',
    passwordPlaceholder: 'ログインパスワードを入力してください（6～12文字の半角英数字）',
    codePlaceholder: '招待コードを入力してください',
    protocol: '「利用規約」を確認のうえ、同意します',
    submit: '登録',
    codeRequired: '招待コードを入力してください。',
    agreementRequired: '下記の「利用規約」に同意してください。',
  },
}
